


























































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import LocationDto from "@/models/Locations/LocationDto";
import UpdateLocationProfileDetailsRequest from "@/models/Locations/UpdateLocationProfileDetailsRequest";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { LocationDetailsModule } from "@/store/modules/locationDetails";


@Component({
  name: "CompanyLocationProfileDetailsEdit",
})
export default class extends GiganautVueDialog {

public entity = new LocationDto();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(
        JSON.stringify(LocationDetailsModule.currentLocation)
      );
    }
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateLocationProfileDetailsRequest();
    request.updatedAt = LocationDetailsModule.currentLocation.updatedAt;
    request.brandName = this.entity.brandName;
    request.website = this.entity.website;
    request.arrivalInstructions = this.entity.arrivalInstructions;
    request.parkingInstructions = this.entity.parkingInstructions;
    await LocationDetailsModule.editLocationProfileDetails(request);
    this.dialog = false;
  }
}
